export const SAVVY_WOB_URL =
  'https://res.cloudinary.com/hbb0rvydd/image/upload/v1689113025/website-assets/small_black_logo.png';
